module.exports = __webpack_public_path__ + "assets/img/social/instagram-icon.bd2576a55c7f46345a00e717bc7b35df.svg";